<template>
    <div class="container">
        <div class="row">
            <div class="nav-bar nav-bar-for-row bg-white box-shadow col-12">
                <nav class="navbar navbar-expand-lg navbar-light navbar-right">
                    <span class="navbar-brand d-inline-block d-lg-none">{{nameAndRoute[nameAndRoute.findIndex(el=>el.routeName === $route.name)].text}}</span>
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#UserProfileNavbar" aria-controls="UserProfileNavbar" aria-expanded="false" aria-label="Toggle sub-navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse nav-tabs" id="UserProfileNavbar">
                        <template v-for="(data, index) in nameAndRoute">
                            <div class="nav-item">
                                <router-link class="nav-link p-2 text-dark" v-bind:class="{'active': $route.name === data.routeName}" v-bind:to="{name: data.routeName}">
                                    {{data.text}}
                                </router-link>
                            </div>
                        </template>
                    </div>
                </nav>
            </div>
        </div>
        <router-view class="row bg-white"></router-view>
    </div>
</template>

<style lang="scss" scoped>
    @import "@/../sass/_navbar.scss";
</style>

<script>

  export default {
    components: {
    },
    data () {
      return {
        nameAndRoute: [
          {
            text: 'Notification',
            routeName: 'user-notification',
          },
        ]
      }
    },
    mounted () {
    }
  }
</script>